import { NumberFieldUI } from '../NumberField/NumberFieldUI';
import { TextFieldUIProps } from '../TextField/TextFieldUI';

export const PhoneFieldUI = <Fields extends object>(
  props: TextFieldUIProps<Fields>
) => (
  <NumberFieldUI<Fields> type="tel" autoComplete="tel-national" {...props} />
);
